var _path, _path2, _g, _path3, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 104,
    viewBox: "0 0 88 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0228 7.78535C42.3036 6.46852 45.1137 6.46852 47.3945 7.78535L76.7314 24.723C79.0122 26.0398 80.4172 28.4734 80.4172 31.1071V64.9824C80.4172 67.6161 79.0122 70.0497 76.7314 71.3665L47.3945 88.3042C45.1137 89.621 42.3036 89.621 40.0227 88.3042L10.6859 71.3665C8.40504 70.0497 7 67.6161 7 64.9824V31.1071C7 28.4734 8.40504 26.0398 10.6859 24.723L40.0228 7.78535Z",
    fill: "#FFECA9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8834_9395",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 65,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.9152C42.7172 11.8453 45.0004 11.8453 46.8535 12.9152L72.7845 27.8865C74.6377 28.9564 75.7793 30.9337 75.7793 33.0736V63.0161C75.7793 65.156 74.6377 67.1333 72.7845 68.2032L46.8535 83.1745C45.0004 84.2444 42.7172 84.2444 40.864 83.1745L14.933 68.2032C13.0798 67.1333 11.9382 65.156 11.9382 63.0161V33.0736C11.9382 30.9337 13.0798 28.9564 14.933 27.8865L40.864 12.9152Z",
    fill: "#8D61E8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8834_9395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8639 12.9152C42.717 11.8453 45.0002 11.8453 46.8534 12.9152L72.7844 27.8865C74.6376 28.9564 75.7792 30.9337 75.7792 33.0736V63.0161C75.7792 65.156 74.6376 67.1333 72.7844 68.2032L46.8534 83.1745C45.0002 84.2444 42.717 84.2444 40.8639 83.1745L14.9329 68.2032C13.0797 67.1333 11.9381 65.156 11.9381 63.0161V33.0736C11.9381 30.9337 13.0797 28.9564 14.9329 27.8865L40.8639 12.9152Z",
    fill: "#FCCE2C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.846 45.0601C72.2298 83.5012 12.5546 43.3757 6.58582 9.86818L-27.8162 57.6639L55.5728 117.685L107.846 45.0601Z",
    fill: "#EBAF25"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8834_9395",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 82,
    height: 82
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2998 8.42178C3.2998 5.11386 5.98141 2.43225 9.28934 2.43225H78.3993C81.7072 2.43225 84.3888 5.11386 84.3888 8.42178V49.9237C84.3888 52.2917 82.4692 54.2114 80.1012 54.2114C77.7332 54.2114 75.8136 56.131 75.8136 58.499V63.0137C75.8136 65.1549 74.6706 67.1331 72.8157 68.2026L46.838 83.1801C44.9853 84.2483 42.7037 84.2476 40.8517 83.1784L14.9121 68.2032C13.0588 67.1333 11.9171 65.1559 11.9171 63.016V58.52C11.9171 56.1404 9.98809 54.2114 7.60848 54.2114C5.22886 54.2114 3.2998 52.2823 3.2998 49.9027V8.42178Z",
    fill: "#FCCE2C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8834_9395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.7687 19C63.8583 31.3883 54.7739 21.4777 37.4308 21.4777C38.2035 22.8868 52.9158 30.8705 53.4947 32.2142C63.4342 55.2841 45.7425 68.6536 32.4756 70.378C48.2265 70.378 55.1422 68.4178 62.2066 63.5979C65.0479 61.6593 68.8135 57.8167 69.6394 53.6872C65.5101 55.339 64.6842 52.8614 63.8583 52.0355C66.3359 49.5578 72.9428 47.906 74.5945 40.4731C66.3359 42.9507 67.1618 40.4731 67.1618 40.4731C67.1618 37.6049 78.7238 31.3883 73.7687 19Z",
    fill: "#D34949"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1557 46.8415L34.1557 69.3792H36.2204L36.2204 46.8415H57.2475V44.7769H36.2204V24.3926H34.1557V44.7769H12.4639L12.4639 46.8415H34.1557Z",
    fill: "#95999E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2122 47.3497L51.1488 63.2862L52.6087 61.8263L36.6722 45.8897L51.5406 31.0213L50.0806 29.5613L35.2122 44.4297L20.7984 30.0159L19.3384 31.4759L33.7523 45.8897L18.4138 61.2281L19.8738 62.6881L35.2122 47.3497Z",
    fill: "#95999E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0781 46.2546C57.0781 58.02 47.5406 67.5576 35.7757 67.5576C24.0108 67.5576 14.4734 58.02 14.4734 46.2546C14.4734 34.4892 24.0108 24.9515 35.7757 24.9515C47.5406 24.9515 57.0781 34.4892 57.0781 46.2546Z",
    stroke: "#95999E",
    strokeWidth: 3.64356
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5517 46.2544C58.5517 58.8336 48.3545 69.031 35.7759 69.031C23.1972 69.031 13 58.8336 13 46.2544C13 33.6752 23.1972 23.4778 35.7759 23.4778C48.3545 23.4778 58.5517 33.6752 58.5517 46.2544Z",
    stroke: "#2C2E30",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.91481,
    cy: 2.91489,
    rx: 2.91481,
    ry: 2.91489,
    transform: "matrix(1 0 0 -1 32.3 48.8298)",
    fill: "#313131"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8834_9395)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 27.5,
    width: 16,
    height: 39,
    rx: 3.5,
    fill: "white",
    stroke: "#FFECA9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85 35L78.5 31L72 35",
    stroke: "#BB8A1A",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M85 41L78.5 37L72 41",
    stroke: "#BB8A1A",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 47L78.5 43L72 47",
    stroke: "#BB8A1A",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 53L78.5 49L72 53",
    stroke: "#BB8A1A",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 59L78.5 55L72 59",
    stroke: "#BB8A1A",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 65L78.5 61L72 65",
    stroke: "#BB8A1A",
    strokeWidth: 4,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 28,
    width: 15,
    height: 38,
    rx: 3,
    stroke: "#FFECA9",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8834_9395"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 27,
    width: 17,
    height: 40,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.f71158b4d3e9e62c3f3afef8b78f6dd4.svg";
export { ForwardRef as ReactComponent };